<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="#676767" dark dense>
            <v-toolbar-title>PERITOS</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
              <template v-slot:activator="{ on }">
                <v-toolbar-items>
                  <v-btn dark text v-on="on">
                    Nuevo
                  </v-btn>
                </v-toolbar-items>
              </template>
              <v-toolbar dark color="primary">
                <v-toolbar-items>
                  <v-btn text dark @click.native="close">
                    <v-icon>mdi-close</v-icon>Cancelar
                  </v-btn>
                </v-toolbar-items>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark text @click.native="addUser(editedItem)" :disabled="!valid" :loading="loading">
                    <v-icon>mdi-content-save-outline</v-icon>Guardar
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                  <v-spacer></v-spacer>
                  <!-- FOLIO:
                  <span class="ml-1" v-if=" editedIndex == -1">{{ nextFolio }}</span>
                  <span class="ml-1" v-else>{{ editedItem.folio }}</span> -->
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs6>
                          <v-select
                            v-model="role"
                            :items="listRoles"
                            item-text="name"
                            item-value="id"
                            label="Rol"
                          ></v-select>
                          <!-- @change="calcularPermissos" -->
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field v-model.trim="editedItem.folio" type="number" label="Folio" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field v-model.trim="editedItem.nombre" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field v-model.trim="editedItem.primer_apellido" label="Primer Apellido" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field v-model.trim="editedItem.segundo_apellido" label="Segundo Apellido">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-menu
                            v-model="menuDatepicker"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="computedDateFormatted"
                                label="Fecha de Nacimiento"
                                hint="DD/MM/YYYY"
                                persistent-hint
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="date"
                              :max="new Date().toISOString().substr(0, 10)"
                              no-title
                              @input="menuDatepicker = false"
                              locale="es-es"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field v-model.trim="editedItem.email" label="Correo Sistema Peritos" :rules="emailRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field v-model.trim="editedItem.email_contacto" label="Correo Contacto" :rules="emailRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            label="Género"
                            :rules="notBlankRules"
                            :items="generos"
                            item-text="text"
                            item-value="id"
                            v-model="editedItem.genero"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox v-if="editedIndex > -1"
                            v-model="changePassword"
                            label="Cambiar Contraseña"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 v-if="editedIndex == -1 || changePassword">
                          <v-text-field v-model.trim="editedItem.password" label="Contraseña"
                            :type="show ? 'text' : 'password'"
                            :rules="notBlankRules"
                          >
                          </v-text-field>
                          <v-text-field v-model.trim="editedItem.password_confirmation" label="Confirmar Contraseña"
                            :type="show ? 'text' : 'password'"
                            :rules="notBlankRules"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 v-if="!disabledField">
                          <span class="headline" style="color: black;margin-left: -17px;">Permisos</span><br><br>
                          <div v-for="(categoria, categoriaNombre, index) in categorias" :key="index" >
                            <div style="color: #1976d2" >{{categoriaNombre | capitalize}}</div>
                            <v-col>

                              <div v-for="(permission,index) in categoria" :key="index">
                                <v-checkbox
                                  v-model="UserPermissionsList[permission.index].checked"
                                    :label="permission.descripcion"
                                    :disabled="permission.readonly"
                                    :value="UserPermissionsList[permission.index].checked"
                                    :false-value="false"
                                    :true-value="true"
                                    :checked="UserPermissionsList[permission.index].checked"
                                    ></v-checkbox>
                              </div>

                            </v-col>
                          </div>
                        </v-flex>
                        <!-- {{ editedItem.permissions }} -->

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" @click.native="editUser(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                          <v-btn v-else color="yellow darken-2" @click.native="addUser(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-data-table
            dense
            :headers="headers"
            :items="listUsers"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
            hide-default-footer
            :items-per-page="per_page_table"
          >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-row>
                <v-col cols="3" sm="3">
                    <v-autocomplete
                    class="mx-4 mt-8"
                    return-object
                    item-text="name"
                    item-value="id"
                    :items="listRoles"
                    v-model="role"
                    label="Rol"
                    clearable
                    @change="getUsers"
                    ></v-autocomplete>
                </v-col>
              </v-row>
            </v-toolbar>
          </template>
            <template v-slot:item.ncompleto="{ item }">
              {{item.primer_apellido}}
              {{item.segundo_apellido}}
              {{item.nombre}}
            </template>
            <template v-slot:item.roles="{ item }">
              <div v-if="item.roles.length">
                {{item.roles[0].name}}
              </div>
            </template>
            <template v-slot:item.permissions="{ item }">
              <v-chip class="ma-1" small v-for="(item, index) in item.permissions" style="min-width: 88px;" :key="index">
                {{ item.descripcion }}
              </v-chip>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
                >
                  mdi-check-bold
              </v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
                >
                  mdi-minus
              </v-icon>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                v-if="permisosList.findIndex(i => i.name === 'edit_users') > -1"
                class="mr-2"
                @click="btnEdit(item)"
                color="orange"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                v-if="!item.deleted_at && permisosList.findIndex(i => i.name === 'delete_users') > -1"
                color="red"
                @click="deleteUser(item)"
              >
                mdi-close
              </v-icon>
            </template>
          </v-data-table>
          <!-- {{listUsers.length}} -->
          <!-- v-if="listUsers.length > pagination.per_page" -->
          <div class="text-center pt-2" >
            <v-pagination
              v-model="pagination.current"
              :length="pagination.total"
              :per-page="pagination.per_page"
              :total-visible="7"
              @input="onPageChange"
            ></v-pagination>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {
  data() {
    return {
      date: '',
      names: [
        {
          id: 1,
          name: "edit_users",
          descripcion: "Permitir actualizar los datos de un usuario",
          created_at: "2020-08-03 16:28:06",
          updated_at: "2020-08-03 16:28:06",
          checked: true,
          deleted_at: null
        },
        {
          id: 2,
          name: "add_user",
          descripcion: "Permitir actualizar los datos de un usuario",
          created_at: "2020-08-03 16:28:06",
          updated_at: "2020-08-03 16:28:06",
          checked: false,
          deleted_at: null
        },
        {
          id: 3,
          name: "delete_users",
          descripcion: "Permitir actualizar los datos de un usuario",
          created_at: "2020-08-03 16:28:06",
          updated_at: "2020-08-03 16:28:06",
          checked: false,
          deleted_at: null
        }
      ],
      pagination: {
        current: 1,
        total: 0,
        per_page: ''
      },
      per_page_table: 5,
      changePassword:false,
      menuDatepicker: false,
      mask: '##########',
      celular: '',
      valid: true,
      dialog: false,
      loading:false, //component
      show: false,
      headers: [
        { text: 'Folio', align: 'left', sortable: true, value: 'folio' },
        { text: 'Nombre', value: 'ncompleto', sortable: true },
        { text: 'Usuario', value: 'email', sortable: true },
        { text: 'Email Contacto', value: 'email_contacto', sortable: true },
        { text: 'Género', value: 'genero', sortable: true },
        // { text: 'Permisos Adicionales', value: 'permissions', sortable: true },
        { text: 'Activo', value: 'activo', sortable: false },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '15%' }
      ],
      listRoles: [],
      listUsers: [],
      permissionsList: [],
      UserPermissionsList: [],
      distritosList:[],
      editedIndex: -1,
      activo: true,
      role:'',
      disabledField: true,
      editedItem: {
        folio:'',
        permissions:[],
        email:'',
        email_contacto:'',
        genero:'',
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        fec_nacimiento:'',
        password: '',
        password_confirmation:'',
        editedItem: null,
        officeable_type: null
      },
      defaultItem: {
        folio:'',
        permissions:[],
        email:'',
        email_contacto:'',
        genero:'',
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        fec_nacimiento:'',
        password: ''
      },
      nextFolio:'',
      generos: [
        { text: 'Hombre', id:'H' },
        { text: 'Mujer', id:'M' },
      ],
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo valido',
      ]
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters([
        "permisosList", "currentUser"
    ]),
    checkedNames () {
      if (this.permissionsList.length) {
        return this.names.filter(item => item.checked).map(name => name.name)
      }
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    },
    categorias(){
      return groupBy(this.permissionsList, 'categoria')
    }
  },
  mounted() {
    this.getUsers();
    this.getRoles();
    this.getPermisos();
    // this.getNextFolio();
  },
  watch: {

  },
  methods: {
    formatDate (date) {
     if (!date) return null
     const [year, month, day] = date.split('-')
     return `${day}/${month}/${year}`
   },
    getUsers() {
      this.filtros = {
        role_id: this.role ? this.role.id : undefined,
      };
      this.$store.dispatch("GET_USERS",  { url: "users?page=" + this.pagination.current,  data: this.filtros } )
        .then(response => {
          this.pagination.current = response.data.data.users.current_page;
          this.pagination.total = response.data.data.users.last_page;
          this.per_page_table = response.data.data.users.per_page;
          this.listUsers = response.data.data.users.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onPageChange() {
      this.getUsers();
    },
    getRoles() {
      this.$store.dispatch("GET_ROLES",  { url: "roles/list" } ).then(response => {
        let roles = response.data.data.roles;
        if (this.currentUser.id == 1) {
          this.listRoles = response.data.data.roles
        } else {
          roles.forEach(element => {
            if (element.id == 3) {
              this.listRoles.push(element);
              this.role = 3
            }
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
    },
    getPermisos() {
      this.$store.dispatch("GET_PERMISOS",  { url: "permissions" } ).then(response => {
          this.permissionsList = response.data.data.permissions;//usar response para datos, se puede usar getters
        })
        .catch(err => {
          console.log(err);
        });
    },
    btnEdit (item) {
      this.role = item.roles[0].id;
      this.editedIndex = this.listUsers.indexOf(item)
      this.date = item.fec_nacimiento
      this.editedItem = Object.assign({}, item)
      // Calculamos los permisos
      // this.calcularPermissos();
      this.dialog = true
      // this.UserPermissionsList = this.permissionsList.map(a => {return {...a}});
      // console.log('UserPermissionsList', this.UserPermissionsList );
      if (this.editedItem.deleted_at) {
        this.activo = false
      }else {
        this.activo = true
      }
    },
    addUser(){
      if (this.$refs.form.validate()) {
        this.editedItem.role = this.role;
        this.editedItem.fec_nacimiento = this.date;
        this.loading = true;
        var data = this.editedItem;
        this.$store.dispatch("SAVE_USERS",  { url: "/user", data: data } ).then(response => {
            this.close ();
            Swal.fire({
              icon: 'success',
              title: 'Usuario agregado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getUsers();
            // this.getNextFolio();
            //this.roles = response.data;//usar response para datos, se puede usar getters
          })
          .catch(error => {
            console.log(error.response);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response.data.status,
                confirmButtonText: "Aceptar"
              })
          });
        this.loading = false;
      }
    },
    editUser(item){
      item.fec_nacimiento = this.date;
      item.activo = this.activo;
      // Copiamos únicamente los permisos con check y no son readonly.
       this.editedItem.permissions = this.UserPermissionsList.map(function(permission){
         if(permission.checked && !permission.readonly){
           return {...permission}
         }
         return null;
       });
      this.editedItem.role = this.role;
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("EDIT_USER",  { url: "/user/" + item.id, data: item } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Usuario actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.getUsers();
          //this.roles = response.data;//usar response para datos, se puede usar getters
          this.loading = false;
          this.close()
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: err.response.data.status,
            confirmButtonText: "Aceptar"
          })
          this.loading = false;
          this.close()
        });

      }
    },
    deleteUser(item){
      this.$swal({
        title: '¿Desea eliminar al usuario ' + item.name + '?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_USER",  { url: "/user/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Usario eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getUsers();
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.resetValidation()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
        // this.role = ''
        this.disabledField = true
      }, 300)
    },
    calcularPermissos (){
      if (this.role) {
        this.UserPermissionsList = [];
        this.disabledField = false;
        this.permissionsList.forEach((all_permission,index) => {
          all_permission.checked = false;
          all_permission.readonly = false;
          all_permission.index = index;
          //Inactivar de todos los permisos, los permisos de acuerdo al rol seleccionado
          this.listRoles[this.role-1].permissions.forEach(permission => {
            if (all_permission.id == permission.id) {
              all_permission.checked = true
              all_permission.readonly = true
            }
          });
          //Inactivar de todos los permisos, los permisos adicionales
          this.editedItem.permissions.forEach((permission) => {
            if (all_permission.id == permission.id) {
              all_permission.checked = true;
            }
          });
        });
        this.UserPermissionsList = this.permissionsList.map(a => {return {...a}});

        //
        //si es una sala
        if(this.role === 3){
          this.editedItem.officeable_type = 'App\\Models\\Sala';
        // si es un centro
        }else if(this.role === 4){
          this.editedItem.officeable_type = 'App\\Models\\Centro';
        }else{
          this.editedItem.officeable_type = undefined;
          this.editedItem.officeable_id = undefined;

        }
      }
    },
    // getNextFolio() {
    //   this.$store.dispatch("GET_FOLIO",  { url: "peritos/next-folio" } ).then(response => {
    //       this.nextFolio = response.data.data.folio;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
  }
}

function groupBy(array, key){
  const result = {}
  array.forEach(item => {
    if (!result[item[key]]){
      result[item[key]] = []
    }
    result[item[key]].push(item)
  })
  return result
}
</script>
